/*
 *
 * LeftMenu
 *
 */

import React from 'react';
import {
  Wrapper,
  NavContainer,
  Content,
  HomeIcon,
  SignOutButton,
  MenuList,
  A
} from './styledComponents';
import Button from './Button';
import Logo from 'components/Logo';
import Icon from 'components/Icon';

const LeftMenu = ({ children, avatarUrl, signOut }) => (
  <Wrapper>
    <NavContainer>
      <MenuList>
        <HomeIcon>
          <Logo name='home' />
        </HomeIcon>
        <Button resource='channels' name='Channels' iconName='channels' />
        <Button resource='leads' name='Leads' iconName='leads' />
        <Button href='https://help.mvbth.com' target="_blank" rel="noreferrer noopener" iconName='help' name="Help" />
        <Button resource='account' name='Settings' iconName='account' />
      </MenuList>
      <SignOutButton onClick={() => signOut()}>
        Sign out
      </SignOutButton>
    </NavContainer>
    <Content>
      {children}
      <Icon className="footer-logo" viewBox="0 0 123 10" width='123' height="10" name='faded_logo' />
    </Content>
  </Wrapper>
);

export default LeftMenu;



// WEBPACK FOOTER //
// ./src/components/LeftMenu/index.js